import { Outlet } from "react-router-dom"
const MainTasks = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainTasks;